// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { getMinutes as fn } from "../getMinutes.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const getMinutes = convertToFP(fn, 1);

// Fallback for modularized imports:
export default getMinutes;
